//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import UploadSIEFormContainer from "./uploadSIEFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSIEFileUploadDialog(onActionSuccess?: () => void): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.UploadSIEFile),
    titleIcon: IconDefinitionConstants.WDocument,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        successMessage: TranslationKeys.Document.CreateSuccess,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <UploadSIEFormContainer />,
    maxWidth: "sm",
    onSubmit: onActionSuccess,
  };
}

export default useSIEFileUploadDialog;
